import React, { useState } from 'react';
import {
  Box, Typography, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Chip, FormControl, InputLabel, Select, MenuItem,
} from '@mui/material';
import { promociones, formatearFecha, nombreTienda } from '../data';

function Promotions() {
  const [filtroSucursal, setFiltroSucursal] = useState('');

  const filtradas = promociones.filter(p => !filtroSucursal || p.sucursal === filtroSucursal);

  const hoy = new Date();
  const esVigente = (p) => {
    const ini = new Date(p.fecha_inicio);
    const fin = new Date(p.fecha_fin);
    return p.estado === 'activo' && hoy >= ini && hoy <= fin;
  };

  return (
    <Box>
      <Typography variant="h4" fontWeight={700} mb={3}>Promociones</Typography>

      <Box display="flex" gap={2} mb={2}>
        <FormControl size="small" sx={{ minWidth: 180 }}>
          <InputLabel>Sucursal</InputLabel>
          <Select value={filtroSucursal} label="Sucursal" onChange={e => setFiltroSucursal(e.target.value)}>
            <MenuItem value="">Todas</MenuItem>
            <MenuItem value="tizayuca">Bodega Central Tizayuca</MenuItem>
            <MenuItem value="tecamac">Tienda Física Tecámac</MenuItem>
            <MenuItem value="cdmx">Tienda Física CDMX</MenuItem>
            <MenuItem value="ecommerce">E-commerce</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Nombre</TableCell>
              <TableCell align="center">%</TableCell>
              <TableCell>Prioridad</TableCell>
              <TableCell>Vigencia</TableCell>
              <TableCell>Sucursal</TableCell>
              <TableCell>Categorías</TableCell>
              <TableCell align="center">Estado</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filtradas.map(p => {
              const vigente = esVigente(p);
              return (
                <TableRow key={p._id} hover>
                  <TableCell>
                    <Typography variant="body2" fontWeight={600}>{p.nombre}</Typography>
                    <Typography variant="caption" color="text.secondary">{p.descripcion}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Chip label={`${p.porcentaje_descuento}%`} color="primary" size="small" />
                  </TableCell>
                  <TableCell>{p.prioridad}</TableCell>
                  <TableCell>
                    <Typography variant="caption" display="block">
                      {formatearFecha(p.fecha_inicio)} → {formatearFecha(p.fecha_fin)}
                    </Typography>
                    {vigente && <Chip label="Vigente" size="small" color="success" />}
                  </TableCell>
                  <TableCell><Chip label={nombreTienda(p.sucursal)} size="small" variant="outlined" /></TableCell>
                  <TableCell>
                    {p.categorias.map((c, i) => (
                      <Chip key={i} label={c} size="small" variant="outlined" sx={{ mr: 0.5, mb: 0.5 }} />
                    ))}
                    {p.productos.map(pr => (
                      <Typography key={pr._id} variant="caption" display="block">{pr.nombre}</Typography>
                    ))}
                  </TableCell>
                  <TableCell align="center">
                    <Chip label={p.estado === 'activo' ? 'Activa' : 'Inactiva'} size="small" color={p.estado === 'activo' ? 'success' : 'default'} />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default Promotions;
